type ToastType = "success" | "error" | "info";

export type ToastPayload = {
  type: ToastType;
  message: string;
  actionText?: string;
  onAction?: () => void;
};

let emitToast: ((toast: ToastPayload) => void) | null = null;

export const toast = {
  success(
    message: string,
    options?: { actionText?: string; onAction?: () => void }
  ) {
    emitToast?.({
      type: "success",
      message,
      ...options,
    });
  },

  error(message: string) {
    emitToast?.({ type: "error", message });
  },
  info(message: string) {
    emitToast?.({ type: "info", message });
  },
};

export function registerToastEmitter(fn: (toast: ToastPayload) => void) {
  emitToast = fn;
}
